var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"activity-indicator",style:({ height: _vm.chosenSize + 'px', width: _vm.chosenSize + 'px' }),attrs:{"src":require('../assets/img/nebula.png')}})}
var staticRenderFns = []

export { render, staticRenderFns }